document.addEventListener('DOMContentLoaded', function() {
  const trigger = document.querySelector('.newsletter-popup-trigger');
  if (!trigger) return;
  
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    showNewsletterPopup();
  });
});

function showNewsletterPopup() {
  const existingPopup = document.getElementById('newsletter-popup');
  if (existingPopup) {
    existingPopup.remove();
  }
  
  const popup = document.createElement('div');
  popup.id = 'newsletter-popup';
  popup.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.7);z-index:9999;display:flex;align-items:center;justify-content:center;';
  
  popup.innerHTML = '<div style="background:white;padding:30px;border-radius:10px;max-width:400px;width:90%;"><h3 style="margin:0 0 20px 0;text-align:center;">メルマガ登録</h3><form action="/contact#newsletter" method="post"><input type="hidden" name="form_type" value="customer"><input type="email" name="contact[email]" placeholder="メールアドレス" required style="width:100%;padding:12px;border:2px solid #ddd;border-radius:5px;margin-bottom:15px;box-sizing:border-box;"><button type="submit" style="width:100%;padding:12px;background:#333;color:white;border:none;border-radius:5px;cursor:pointer;margin-bottom:10px;">登録する</button><button type="button" onclick="document.getElementById(\'newsletter-popup\').remove()" style="width:100%;padding:10px;background:#f5f5f5;border:1px solid #ddd;border-radius:5px;cursor:pointer;">閉じる</button></form></div>';
  
  document.body.appendChild(popup);
}
